import React from 'react';
import Container from 'reactstrap/lib/Container';
import { ShowError } from 'client/site-modules/shared/components/show-error/show-error';

function ErrorPageMessageProd() {
  return (
    <Container className="my-3">
      <h2 className="text-center display-1 error-page-message">we&apos;ve had a minor breakdown.</h2>
    </Container>
  );
}

export function ErrorPageMessage({ error, message }) {
  return <ShowError error={error} message={message} EndUserView={ErrorPageMessageProd} />;
}
